import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { UserAuthService } from 'src/app/auth/userAuth.service';
import { MaterialModule } from 'src/app/material.module';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { UserService } from '../../user/user.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ToastrService } from 'ngx-toastr';
import { ChangePasswordComponent } from "../change-password/change-password.component";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MY_FORMATS } from 'src/app/common/dateFormat';
import { MatMenuTrigger } from '@angular/material/menu';
import { WebcamDialogComponent } from '../../dialogs/webcam-dialog/webcam-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { FallbackImageDirective } from 'src/app/common/directive/fallback-image.directive';
import { LoaderComponent } from "src/app/shared/loader/loader.component";
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { DoctorSpecialityDetailComponent } from '../hospital-setting/doctor-speciality/doctor-speciality-detail/doctor-speciality-detail.component';
import { LookupService } from 'src/app/services/lookup.service';
import { CommonDropDown } from 'src/app/common/types/dropdown.type';
import { ValidationService } from 'src/app/common/validation/validation.service';
import { AllowOnlyDigitsDirective } from 'src/app/common/directive/allow-only-digits.directive';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';
import { Subject, takeUntil } from 'rxjs';
import { AvailabilityComponent } from '../../dialogs/availability/availability.component';
import { UserAvalibility } from '../../user/iusers';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    ChangePasswordComponent,
    TranslateModule,
    FallbackImageDirective,
    LoaderComponent,
    AllowOnlyDigitsDirective,
    AvailabilityComponent
  ],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {
  userdetail: any;
  showAddPhotoOverlay = false;
  userDetailsForm: FormGroup;
  minDate: Date;
  maxDate: Date = new Date();
  imageUrl: string | ArrayBuffer | null = null;
  isLoading: boolean = false;
  defaultAvatarPath = 'assets/images/profile/user-1.jpg';
  Imagefilename: string;
  selectedImage: File | null = null;
  DoctorSpeciality: CommonDropDown[] = [];
  avalibility: UserAvalibility;
  private destroy$ = new Subject<void>();
  hidePan = true;
  hideAadhaar = true;

  constructor(
    private _userAuthservice: UserAuthService,
    private _userservice: UserService,
    private _formBulider: FormBuilder,
    private toastr: ToastrService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private loaderService: LoaderService,
    private _lookupService: LookupService,
    private translationUtils: TranslationUtils
  ) {
    this.minDate = new Date(1800, 0, 1);
    this.userDetailsForm = this._formBulider.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      email: [''],
      birthDate: ['', [Validators.required]],
      panNumber: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidationService.panNumberValidator]],
      aadhaarNumber: [
        '',
        [Validators.required, Validators.maxLength(12), Validators.minLength(12), Validators.pattern("^[0-9]*$")]
      ],
      address: [''],
      avatar: [''],
      joinDate: [''],
      phoneNumber: [
        '',
        [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]*$")]
      ],
      degree: [''],
      specialityId: [''],
      registrationNumber: [''],
      role:[[]]
    });
  }

  ngOnInit(): void {
    //  this.userDetailsForm.get('joinDate')?.disable();
    this._lookupService.getSpeciality()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.DoctorSpeciality = data;
      })
    this.loadUserProfile();
  }

  onFileChanged(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      const file = target.files[0];
      this.Imagefilename = file.name;// name fetch mate chnage if we any thing as into file 
      const reader = new FileReader();
      this.selectedImage = file;
      reader.onload = () => {
        this.imageUrl = reader.result;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);
    }
  }

  onUpdateUserProfile() {
    this.loaderService.show();
    const updateUserData =
    {
      ...this.userDetailsForm.getRawValue(),
      id: this.userdetail?.id
    };
    if (updateUserData.birthDate) {
      updateUserData.birthDate = this.datePipe.transform(updateUserData.birthDate, 'yyyy-MM-dd');
    }

    if (updateUserData.joinDate) {
      updateUserData.joinDate = this.datePipe.transform(updateUserData.joinDate, 'yyyy-MM-dd');
    }

    if (this.selectedImage != null) {
      updateUserData.avatar = this.selectedImage
    } else {
      updateUserData.avatar = this.userdetail.avatar
    }

    const formValues = updateUserData;
    const formData = new FormData();

    Object.keys(formValues).forEach((key) => {
      const value = (formValues as any)[key];
      if (value !== null && value !== undefined && value !== '') {
        formData.append(key, value);
      }
    });

    this._userservice.updateUsers(formData).subscribe((res) => {
      if (res.isSuccess) {
        const updatedUser = res.result;
        this._userAuthservice.setUserData(updatedUser);
        this.loadUserProfile();
        setTimeout(() => {
          this.loaderService.hide();
        }, 1000);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('USERDETAILS')));
      } else {
        const allErrors = Object.values(res.errors).flat();
        this.toastr.error(allErrors.join("\n"));
        this.loaderService.hide();
      }
    })
  }

  removePhoto() {
    this.imageUrl = '';
  }

 get isDoctor(): boolean {
  const roles = this.userdetail?.roleName
    ? this.userdetail.roleName.split(',').map((r: string) => r.trim())
    : [];
  return roles.includes('Doctor') || roles.includes('AsstDoctor');
}
  loadUserProfile() {
    this.loaderService.show();
    this._userAuthservice.get().subscribe((data) => {
      this.userdetail = data.result;
      if (data.result.avatar) {
        this.userdetail.avatar = environment.imagePath + data.result.avatar;
      }
      this.userDetailsForm.patchValue({
        firstname: this.userdetail?.firstName,
        lastname: this.userdetail?.lastName,
        email: this.userdetail?.email,
        birthDate: this.userdetail?.birthDate,
        joinDate: this.userdetail?.joinDate,
        panNumber: this.userdetail?.panNumber,
        aadhaarNumber: this.userdetail?.aadhaarNumber,
        address: this.userdetail?.address,
        avatar: this.userdetail?.avatar,
        phoneNumber: this.userdetail?.phoneNumber,
        degree: this.userdetail?.degree,
        specialityId: this.userdetail?.specialityId,
        registrationNumber: this.userdetail?.registrationNumber,
         role: this.userdetail?.roleName ? this.userdetail.roleName.split(',').map((r: string) => r.trim()) : []  
      });
      setTimeout(() => {
        this.loaderService.hide();
      }, 1000);
      this.cdr.detectChanges();
    })
  }

  takePhotoOnWebCamera() {
    this.showAddPhotoOverlay = false;
    const dialogRef = this.dialog.open(WebcamDialogComponent, {
      width: '500px',
      height: 'auto',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result._imageAsDataUrl) {
          this.imageUrl = result._imageAsDataUrl;
          this.Imagefilename = 'webcam_image.png'; // Set a default name for the webcam image
          this.selectedImage = this.dataURLtoFile(result._imageAsDataUrl, this.Imagefilename);
          this.cdr.detectChanges();
        }

      }
    });
  }

  onMenuClosed() {
    this.showAddPhotoOverlay = false;
  }

  openMenu(trigger: MatMenuTrigger) {
    trigger.openMenu();
  }

  dataURLtoFile(dataurl: string, filename: string): File {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  onAddSpeciality() {
    this.dialog.open(DoctorSpecialityDetailComponent, {
      width: '600px',
      height: 'auto',
    }).afterClosed().subscribe((res) => {
      if (res) {
        this._lookupService.getSpeciality()
          .pipe(takeUntil(this.destroy$))
          .subscribe((response) => {
            this.DoctorSpeciality = response;
            this.userDetailsForm.get('specialityId')?.setValue(res.result.id);
          });
      }
    });
  }

  avalibilityCheck(data: UserAvalibility) {
    this.avalibility = data;
  }

  getRolesArray(roleName: string | null): string[] {
  return roleName
    ? roleName.split(',').map(r => r.trim())
    : [];
}
}
